import Vue from 'vue'
import ModalOperator from './ModalOperator'

export default {
  bind(el, binding, node) {
    saveModalInfo(el, getInfo(binding, node))
    el.removeEventListener('click', clickHandler)
    el.addEventListener('click', clickHandler)
  },

  update(el, binding, node) {
    saveModalInfo(el, getInfo(binding, node))
  },

  unbind(el) {
    removeModalInfo(el)
    el.removeEventListener('click', clickHandler)
  },
}

function getInfo(binding, node) {
  const value = binding.value
  const attrs = node.data.attrs
  const pre = 'modal'

  // 需要保存的属性
  const info = { value }
  info.content = attrs[`${pre}-content`]
  info.config = attrs[`${pre}-config`]
  info.props = attrs[`${pre}-props`]
  info.success = attrs[`${pre}-success`] || function() {}

  return info
}

const Modals = {}
let Index = 0
function saveModalInfo(el, info) {
  let i = el.dataset._modal
  if (!i) {
    i = `${Index++}`
    el.dataset._modal = i
  }
  Modals[i] = info
}
function getModalInfo(el) {
  const i = el.dataset._modal
  return Modals[i]
}
function removeModalInfo(el) {
  const i = el.dataset._modal
  if (i) {
    delete Modals[i]
  }
}

function openModal(el) {
  const info = getModalInfo(el)
  render(info)
}

function render(info) {
  if (!info) return
  const {
    value,
    content,
    config,
    success,
  } = info

  const root = new Vue({
    provide() {
      return {
        $Container: this,
        $Row: this,
      }
    },
    render(h) {
      return h(content, {
        attrs: {
          'modal-config': config,
        },
        props: {
          value,
        },
        on: {
          success,
        },
      })
    },
  }).$mount().$children[0]
  const modal = root.$children[0]

  if (modal.open instanceof Function) {
    modal.open()
  } else {
    root.$destroy()
    pureRender(info)
  }
}

function pureRender(info) {
  if (!info) return
  const {
    value,
    content,
    config,
    success,
  } = info

  const root = new Vue({
    provide() {
      return {
        $Container: this,
        $Row: this,
      }
    },
    render(h) {
      return h(ModalOperator, {
        props: {
          config,
          pure: true,
        },
        on: {
          success,
        },
      }, [
        h(content, {
          ref: 'Content',
          props: { value },
        }),
      ])
    },
  }).$mount()
  root.$children[0].open()
}

function clickHandler(e) {
  e.preventDefault()
  e.stopPropagation()
  openModal(this)
}
